import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesPrintAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesPrintAction() {
  return fetchApi('/v1/fc_api/feeding_guidelines_print_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesPrintAction;
